// extracted by mini-css-extract-plugin
module.exports = {"spacer":"spacer__-znOM"};